























import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {Profile} from '@/model/network/profile/Profile';
import {Connection} from '@/model/network/connection/Connection';

import {ConnectionType} from '@/model/network/connection/ConnectionType';

import {INetworkConnectionService} from '@/services/network/INetworkConnectionService';
import {INetworkProfileService} from '@/services/network/INetworkProfileService';

import NetworkIpSettingsDisplay from '@/components/Networking/Profile/NetworkIpSettingsDisplay.vue';
import NetworkIpStatusDisplay from '@/components/Networking/Connection/NetworkIpStatusDisplay.vue';
import NetworkConnectionsList from '@/components/Networking/Connection/NetworkConnectionsList.vue';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';
import {getModule} from 'vuex-module-decorators';
import {Notify} from '@/utils/Notify';

enum ConnectionGroup {
  Wired = 0,
  VPN = 1,
  Others = 2,
}

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkConnectionsList, NetworkIpSettingsDisplay, NetworkIpStatusDisplay},
})
export default class NetworkConnections extends Mixins<BaseComponent>(BaseComponent) {
  private networkConnectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private ConnectionGroup = ConnectionGroup;

  private connectionGroups = new Map([
    [ConnectionGroup.Wired, 'Wired'],
    [ConnectionGroup.VPN, 'VPN'],
    [ConnectionGroup.Others, 'Others'],
  ]);

  private refreshing: boolean = true;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.logger.debug(`Refreshing data...`);
    this.refreshing = true;

    try {
      await this.networkConnectionsStore.fetchConnections(true);
    } catch (error) {
      Notify.Error(this.logger, `Could not get connections`, error);
    } finally {
      this.refreshing = false;
    }
  }

}
